var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('a-tabs',{on:{"tabClick":_vm.tabClick}},_vm._l((_vm.ordersArray),function(order){return _c('a-tab-pane',{key:order,attrs:{"tab":order}},[_c('order',{attrs:{"order":order}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }